/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { StyledGrid, BodyContainer } from './style';

const OpportunityDetailsTemplate = ({ header, children }) => (
  <div>
    <StyledGrid container>
      <Grid item xs={12}>
        {header}
      </Grid>
      <BodyContainer>
        <Grid item xs={12}>
          {children}
        </Grid>
      </BodyContainer>
    </StyledGrid>
  </div>
);

OpportunityDetailsTemplate.propTypes = {
  children: PropTypes.node.isRequired,
  opportunity: PropTypes.object,
  title: PropTypes.string,
  header: PropTypes.object,
  background: PropTypes.string
};

OpportunityDetailsTemplate.defaultProps = {
  title: undefined,
  header: {},
  opportunity: undefined,
  background: '',
};

export default OpportunityDetailsTemplate;
